// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.user-settings-page .details-item {\n  margin: 1.15rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
